<template>
<div class="chapter">
<div class="inner_page">
<h2>Contents</h2>
<p class="paranoindent1"> </p>
<p class="toc-list1"><b><a href="#/07_Foreword#foreword" id="toc-foreword">Foreword </a></b></p>
<p class="toc-list1"><b><a href="#/08_Introduction#introduction" id="toc-introduction">Introduction</a></b></p>
<p class="toc-list1"><a href="#/09_Chapter1#ch1" id="toc-ch1"><b>Chapter One.</b> 1914–15. Regular blood</a></p>
<p class="toc-list1"><span href="#/10_Chapter2#ch2" id="toc-ch2" title="Link target outside of Sample"><b>Chapter Two.</b> 1915–16. Lead us not into temptation</span></p>
<p class="toc-list1"><span href="#/11_Chapter3#ch3" id="toc-ch3" title="Link target outside of Sample"><b>Chapter Three.</b> 1916. Kitchener’s men.</span></p>
<p class="toc-list1"><span href="#/12_Chapter4#ch4" id="toc-ch4" title="Link target outside of Sample"><b>Chapter Four.</b> 1916. And the meek shall inherit the earth</span></p>
<p class="toc-list1"><span href="#/13_Chapter5#ch5" id="toc-ch5" title="Link target outside of Sample"><b>Chapter Five.</b> You can’t get away from the guns</span></p>
<p class="toc-list1"><span href="#/14_Chapter6#ch6" id="toc-ch6" title="Link target outside of Sample"><b>Chapter Six.</b> 1917. Far, far from Wipers I long to be</span></p>
<p class="toc-list1"><span href="#/15_Chapter7#ch7" id="toc-ch7" title="Link target outside of Sample"><b>Chapter Seven.</b> 1917. There is a limit to the number of good men</span></p>
<p class="toc-list1"><span href="#/16_Chapter8#ch8" id="toc-ch8" title="Link target outside of Sample"><b>Chapter Eight.</b> 1918. With our backs to the wall</span></p>
<p class="toc-list1"><span href="#/17_Chapter9#ch9" id="toc-ch9" title="Link target outside of Sample"><b>Chapter Nine.</b> 1918–20. Lord let us now thy servants depart in peace</span></p>
<p class="toc-list1"><span href="#/18_Acknowledgement#acknowledgement" id="toc-acknowledgement" title="Link target outside of Sample"><b>Acknowledgements</b></span></p>
<p class="toc-list1"><span href="#/19_Bibliography#bibliography" id="toc-bibliography" title="Link target outside of Sample"><b>Bibliography</b></span></p>
<p class="toc-list1"><span href="#/20_Appendix#appendix" id="toc-appendix" title="Link target outside of Sample"><b>Appendix</b></span></p>
<p class="toc-list2"><span href="#/20_Appendix#app1" id="toc-app1" title="Link target outside of Sample">Place of Burial or Commemoration of Executed Men</span></p>
<p class="toc-list2"><span href="#/20_Appendix#app2" id="toc-app2" title="Link target outside of Sample">Executions in Regimental or Unit Order</span></p>
<p class="toc-list2"><span href="#/20_Appendix#app3" id="toc-app3" title="Link target outside of Sample">Executions on the Western Front</span></p>
<p class="toc-list2"><span href="#/20_Appendix#app4" id="toc-app4" title="Link target outside of Sample">Executions in ‘Other Theatres’</span></p>
<p class="toc-list1"><span href="#/21_Index#index" id="toc-index" title="Link target outside of Sample"><b>Index.</b> Alphabetical list of all those executed</span></p>
<p class="paranoindent2" style="margin-top: 1em">British firing squad in action. The shooting is that of a spy in Belgium early in<br/>the war. [Penalty not inflicted by authority of the Army Act.]</p>
<div class="paracenter">
<div class="image">
<img alt="image" src="images/contents-1.jpg" style="max-width:100%"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?3fcceb54